var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.newMessage, function(message, index) {
      return _c(
        "div",
        { key: index, staticClass: "chat-widget" },
        [
          _c("div", { staticClass: "split" }, [
            _c("div", { staticClass: "split-box" }, [
              _vm._v(_vm._s(_vm.timeAgo(message.date)))
            ])
          ]),
          _vm._l(message.messageOfDate, function(messageDate, index2) {
            return _c(
              "div",
              {
                key: index2,
                staticClass: "chat-container",
                class: _vm.isMe(messageDate.userID)
              },
              [
                _c("div", { staticClass: "full-box" }, [
                  _vm._v(_vm._s(messageDate.userName) + "    "),
                  _c("span", { staticClass: "has-text-primary" }, [
                    _vm._v("#" + _vm._s(messageDate.roleID))
                  ])
                ]),
                _c("div", { staticClass: "chat-person" }, [
                  _vm.haveImage(messageDate.userID)
                    ? _c("img", {
                        staticClass: "image-avatar",
                        attrs: {
                          title: messageDate.userName,
                          src:
                            "https://api.musubi-thai.com/public/profile/" +
                            _vm.getPersonImage(messageDate.userID)
                        }
                      })
                    : _c("img", {
                        staticClass: "image-avatar",
                        attrs: {
                          src: "https://services.musubi-thai.com/default.png",
                          alt: "Placeholder image"
                        }
                      })
                ]),
                _c(
                  "div",
                  { staticClass: "chat-message" },
                  _vm._l(messageDate.msgOfUser, function(msg, index3) {
                    return _c(
                      "div",
                      { key: index3, staticClass: "message-row" },
                      [
                        _c(
                          "div",
                          { staticClass: "message-conntent" },
                          [
                            message.type == "text"
                              ? [
                                  _vm._v(
                                    _vm._s(msg.text) + "\n\n                "
                                  )
                                ]
                              : _c("span", {
                                  domProps: { innerHTML: _vm._s(msg.text) }
                                })
                          ],
                          2
                        ),
                        _c("div", { staticClass: "time" }, [
                          _vm._v(_vm._s(_vm.showTime(msg.date)))
                        ])
                      ]
                    )
                  })
                )
              ]
            )
          })
        ],
        2
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53e335da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e335da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/chat.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-53e335da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/chat.vue
// module chunks = 0 1 2 3 4